import useDebounce from '@cannect/hooks/utils/useDebounce'
import { hasDocumentsPending, productRecurrencyState } from '@cannect/services/resources/recurrency/helpers'
import { useEligibility, useRecurrencyAccess } from '@cannect/services/resources/recurrency/hooks'

export type RecurrencyChoice = { mode: 'once' | 'subscription'; cycleDays: number | null }

// Elegibilidade e preços de assinante do produto na PDP (delta B2). Quantidade
// e ciclo com debounce de 300 ms; nada é pedido sem acesso (flag + paciente).
export const useProductRecurrency = ({
  productId,
  quantity,
  cycleDays
}: {
  productId?: number
  quantity: number
  cycleDays: number | null
}) => {
  const access = useRecurrencyAccess()
  const debouncedQuantity = useDebounce(quantity, 300)
  const debouncedCycle = useDebounce(cycleDays, 300)
  const query = useEligibility(
    {
      productIds: productId ? [productId] : [],
      quantities: [debouncedQuantity || 1],
      cycleDays: debouncedCycle,
      prices: true,
      // 009: no checkout, documento faltando vira pendência (não bloqueia).
      origin: 'checkout'
    },
    { enabled: Boolean(productId) }
  )
  const view = query.isError ? null : query.data
  const state = access.enabled && productId ? productRecurrencyState(view, productId) : 'hidden'
  const item = view?.items.find((i) => Number(i.productId) === Number(productId)) ?? null

  return {
    state,
    item,
    summary: view?.summary ?? null,
    documentsPending: hasDocumentsPending(view),
    isLoading: access.enabled && Boolean(productId) && query.isLoading
  }
}

export type ProductRecurrency = ReturnType<typeof useProductRecurrency>
